export const handleFeaturedTimer = (): void => {
  const $timer = document.querySelector<HTMLSpanElement>('[data-widget-timer]')
  if ($timer) {
    const actualTime = parseInt($timer.textContent, 10)
    $timer.textContent = String(actualTime > 0 ? actualTime - 1 : 0)
  }
}

export const resetTimer = (): void => {
  const $timer = document.querySelector<HTMLSpanElement>('[data-widget-timer]')
  if ($timer) $timer.textContent = '10'
}
